import React from 'react';
import './titulo.css';

const Titulo = ({ children, children2 }) => {
  return (
    <div className="titulo-container">
      <div className="titulo-children">{children}</div>
      <div className="titulo-children2">{children2}</div>
    </div>
  );
};

export default Titulo;